
import { Component, Vue, Prop } from 'vue-property-decorator'
import { SchoolNoticeVO, SchoolNoticeSlvVO } from '@/views/biz/notice/vo/CalendarVO'
import Calendar from '@/components/Calendar.vue'
import axios from 'axios';
import CommonUtils from '@/common-utils';
import { MemberVO } from '../login/vo/MemberVO.vo';

@Component
export default class SchoolNotice extends Vue {
  @Prop() tab !: string;

  mode = 'stack';

  focus= '';
  type= 'month';
  selectedEvent= {};
  selectedElement= null;
  selectedOpen= false;
  events: Array<object>= [];
  dialog = {
    opened: false,
    data: [] as Array<object>
  };

  notice: SchoolNoticeVO = {} as SchoolNoticeVO;
  schedules: Array<SchoolNoticeSlvVO> = [] as Array<SchoolNoticeSlvVO>;

  get getSchedules(): Array<object> {
    const res: Array<object> = [];
    for (let i = 0; i < this.schedules.length; i++) {
      res.push({
        name: this.schedules[i].ssContent,
        start: this.schedules[i].ssStartDt,
        end: this.schedules[i].ssEndDt,
        color: this.schedules[i].ssColor,
      })
    }
    return res;
  }

  showEvent({ nativeEvent, event }) {
    this.dialog.data = [];
    this.dialog.opened = !this.dialog.opened;
    this.dialog.data.push({
      color: event.color,
      name: event.name,
      start: event.start,
      end: event.end
    })
  }

  showMore({ year, month, day }) {
    this.dialog.data = [];
    axios.get(`/notice/school/${year}/${CommonUtils.getNumberPad(month, 2)}/${CommonUtils.getNumberPad(day, 2)}`)
    .then(r => {
      const res = r.data;
      console.log(res)
      this.dialog.opened = !this.dialog.opened;
      for(const i in res) {
        this.dialog.data.push({
          color: res[i].ssColor,
          name: res[i].ssContent,
          start: res[i].ssStartDt,
          end: res[i].ssEndDt
        })
      }
    })
    
  }

  getEventColor(event) {
    return event.color;
  }

  prev() {
    (this.$refs.calendar as Calendar).prev();
  }

  next() {
    (this.$refs.calendar as Calendar).next();
  }

  getSchoolNotices(year, month) {
    axios.get(`/notice/school/${year}/${month}`)
    .then(r => {
      this.notice = r.data.notice;
      this.schedules = r.data.schedules;
    })
  }

  currentDate(): void {
    const changeCurrentDate = (this.$refs.calendar as Calendar)['lastStart'];
    this.getSchoolNotices(changeCurrentDate.year, CommonUtils.getNumberPad(changeCurrentDate.month, 2));
  }

}
